/*
Copyright (c) 2012-2025 Grab Taxi Holdings PTE LTD (GRAB), All Rights Reserved.
NOTICE: All information contained herein is, and remains the property of GRAB.
The intellectual and technical concepts contained herein are confidential,
proprietary and controlled by GRAB and may be covered by patents, patents in process,
and are protected by trade secret or copyright law.

You are strictly forbidden to copy, download, store (in any medium), transmit, disseminate,
adapt or change this material in any way unless prior written permission is obtained from GRAB.
Access to the source code contained herein is hereby forbidden to anyone except current GRAB
employees or contractors with binding Confidentiality and Non-disclosure agreements explicitly
covering such access.

The copyright notice above does not evidence any actual or intended publication or disclosure of
this source code, which includes information that is confidential and/or proprietary,
and is a trade secret, of GRAB.

ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC PERFORMANCE, OR PUBLIC DISPLAY OF OR
THROUGH USE OF THIS SOURCE CODE WITHOUT THE EXPRESS WRITTEN CONSENT OF GRAB IS STRICTLY PROHIBITED,
AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES. THE RECEIPT OR POSSESSION OF THIS
SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS TO REPRODUCE,
DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE,
IN WHOLE OR IN PART.
*/
/** @jsx jsx */
import { css } from "@emotion/core"

export const customPopoverStyles = css`
  width: 336px;
  padding: 4px;
`

export const modalTitle = css`
  color: #1c1c1c;
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 32px;
  margin-bottom: 32px;
`
export const statusSection = css`
  margin: 16px 0 16px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const statusMiddleSection = css`
  width: 226px;
  cursor: pointer;
`

export const statusText = css`
  color: var(--greys-and-black-grey-900, #1a1a1a);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

export const statusSubText = css`
  color: var(--greys-and-black-grey-500, #707070);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0;
`

export const dividerStyle = css`
  margin: 0;
`

export const confirmButton = css`
  display: inline-block;
  width: 328px;
  height: 48px;
  flex-shrink: 0;
  background: #00b14f;
  margin-top: 16px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 16px; /* 100% */
  border: transparent;

  &:hover {
    background: #00b14f !important;
    color: #fff !important;
  }
  &:active {
    background: #b8e5df !important;
    color: #005339 !important;
  }

  &:disabled {
    cursor: not-allowed;
    border-color: #e8e8e8;
    color: #bfbfbf;
    background: #f5f5f5;
    box-shadow: none;
  }

  &:disabled:hover {
    cursor: not-allowed;
    border-color: #e8e8e8;
    color: #bfbfbf !important;
    background: #f5f5f5 !important;
    box-shadow: none;
  }
`
export const buttonBase = css`
  height: 45px;
  color: #fff;
  border: transparent;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
`

export const greenButton = css`
  background: #00b14f;
  &:hover {
    background: #00b14f !important;
    color: #fff !important;
  }
  &:active {
    background: #b8e5df !important;
    color: #005339 !important;
  }
`

export const orangeButton = css`
  background: #f09800;
  &:hover {
    background: #f09800 !important;
    color: #fff !important;
  }
  &:active {
    background: #f09800 !important;
    color: #fff !important;
  }
`

export const redButton = css`
  background: #f55538;
  &:hover {
    background: #f55538 !important;
    color: #fff !important;
  }
  &:active {
    background: #f55538 !important;
    color: #fff !important;
  }
`
export const vermilionButton = css`
  background: #d42e1c !important;
  color: #fff !important;
  &:hover {
    background: #d42e1c !important;
    color: #fff !important;
  }
  &:active {
    background: #d42e1c !important;
    color: #fff !important;
  }
`

export const radioGroup = css`
  display: flex;
  margin: 0 32px 16px 32px;
  justify-content: space-between;
`
export const radioButton = css`
  width: 83px;
  height: 34px;
  border-radius: 18px !important;
  border: 1px solid var(--greys-and-black-grey-100, #dbdbdb);
  background: var(--greys-and-black-white, #fff);
  display: flex;
  padding: 8px 12px;
  align-items: center;
  color: var(--greys-and-black-grey-600, #575757);
  justify-content: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  white-space: nowrap;
  :not(:first-child)::before {
    display: none !important;
  }
`
export const timePickerContent = css`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 16px;
`
export const timePickerButton = css`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #f0efef;
  border-radius: 10px;

  .duxicon {
    font-size: 20px;
  }

  &.disabled {
    cursor: not-allowed;
    color: #f0efef;
  }

  &.enabled {
    cursor: pointer;
    color: #1495e6;
  }
`
export const timePickerText = css`
  color: #161a1d;
  text-align: center;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  margin: 0 21px;
`

export const tickMarkIcon = css`
  font-size: 26px;
  color: #00b14f;
  align-self: start;
`

export const dotWrapper = css`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;

  .green-dot {
    color: #00b14f;
  }

  .orange-dot {
    color: #f09800;
  }

  .red-dot {
    color: #f55538;
  }
`
